import React, { useState, useEffect } from 'react';
import { useTransition } from 'react-spring';
import axios from 'axios';

import CourseMobile from './PopularCourseMobile';

const CoursesCarouselMobile = () => {
  const [courseIndex, setCourseIndex] = useState(0);
  const [moveNext, setMoveNext] = useState(true);

  const [courses, setCourses] = useState([]);

  useEffect(() => {
    axios.get('/api/v1/courses/popular').then(response => {
      setCourses(response.data.courses);
    });
  }, []);

  const onPrevClick = () => {
    setMoveNext(false);
    setCourseIndex(state => (state - 1 >= 0 ? state - 1 : courses.length - 1));
  };
  const onNextClick = () => {
    setMoveNext(true);
    setCourseIndex(state => (state + 1) % courses.length);
  };
  const transitions = useTransition(courseIndex, p => p, {
    from: { opacity: 0, transform: `translate3d(${moveNext ? '' : '-'}100%,0,0)` },
    enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
    leave: { opacity: 0, transform: `translate3d(${moveNext ? '-' : ''}50%,0,0)` },
    unique: true,
  });

  if (courses.length === 0) {
    return null;
  }

  return (
    <div className="m-courses-carousel">
      {transitions.map(({ item, props }) => {
        const course = courses[item];
        return <CourseMobile key={course._id} style={props} course={course} />;
      })}
      <div className="m-courses-carousel-button is-left-absolute" onClick={onPrevClick}>
        <img src="img/icons/caret-left.svg" />
      </div>
      <div className="m-courses-carousel-button is-right-absolute" onClick={onNextClick}>
        <img src="img/icons/caret-right.svg" />
      </div>
    </div>
  );
};

export default CoursesCarouselMobile;
